(function () {
  if (!window.matchMedia) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const dot = document.createElement('div');
  dot.className = 'ginger-cursor';
  dot.setAttribute('aria-hidden', 'true');
  const ring = document.createElement('div');
  ring.className = 'ginger-cursor__ring';
  ring.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.add('has-ginger-cursor');
  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(dot);
    document.body.appendChild(ring);
  }, { once: true });

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let dotX = mouseX;
  let dotY = mouseY;
  let ringX = mouseX;
  let ringY = mouseY;
  let visible = false;

  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!visible) {
      dotX = mouseX;
      dotY = mouseY;
      ringX = mouseX;
      ringY = mouseY;
      dot.classList.add('is-visible');
      ring.classList.add('is-visible');
      visible = true;
    }
  });

  window.addEventListener('mouseleave', () => {
    dot.classList.remove('is-visible');
    ring.classList.remove('is-visible');
    visible = false;
  });

  // Hover state on interactive elements
  const INTERACTIVE = 'a, button, [role="button"], input, select, textarea, label, summary, [data-mega-item], .collection-card, .product-card, .subcollections-grid__link, [class*="card__link"]';

  document.addEventListener('mouseover', (e) => {
    if (e.target.closest && e.target.closest(INTERACTIVE)) {
      ring.classList.add('is-hover');
      dot.classList.add('is-hover');
    }
  });

  document.addEventListener('mouseout', (e) => {
    if (e.target.closest && e.target.closest(INTERACTIVE) && !e.relatedTarget?.closest?.(INTERACTIVE)) {
      ring.classList.remove('is-hover');
      dot.classList.remove('is-hover');
    }
  });

  // Animation loop with lerp
  function animate() {
    // Dot: snappy follow
    dotX += (mouseX - dotX) * 0.65;
    dotY += (mouseY - dotY) * 0.65;
    // Ring: smoother, slightly delayed
    ringX += (mouseX - ringX) * 0.18;
    ringY += (mouseY - ringY) * 0.18;

    dot.style.transform = `translate3d(${dotX}px, ${dotY}px, 0) translate(-50%, -50%)`;
    ring.style.transform = `translate3d(${ringX}px, ${ringY}px, 0) translate(-50%, -50%)`;
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);
})();
